import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { CSSTransition } from 'react-transition-group';

import media from 'media';

import logoImg from 'assets/svg/infopanel/logo_kso@2x.svg';
import iconKeys from 'assets/svg/infopanel/icon_arrowkeys.svg';
import iconSwipe from 'assets/svg/infopanel/icon_swipe.svg';

import CenteredPanel from './CenteredPanel';
import IconComponent from './IconComponent';
import { TabletUp, Mobile } from '../../media';

const StyledCenteredPanel = styled(CenteredPanel)`
  width: 45.5rem;
  ${media.tablet`
    width: 20.25rem;
  `}
`;

const Content = styled.div`
  box-sizing: border-box;
  padding: 3.91rem 4.06rem;
  background: white;
  box-shadow: 0 2px 9px 2px rgba(25,52,76,0.20);
  text-align: left;
  cursor: auto;

  ${media.tablet`
    padding: 1.38rem;
  `}
`;

const Logo = styled.img`
  ${media.tablet`
    width: 9.38rem;
    height: 3.75rem;
  `}

`;
const H1 = styled.h1`
  font-size: 4.5rem;
  line-height: 0.97;
  letter-spacing: 0.5px;
  margin: 1.88rem 0 1rem 0;
  ${media.tablet`
    margin: .75rem 0 0.38rem 0;
    font-size: 1.75rem;
  `}
`;
const P = styled.p`
  font-size: 1rem;
  font-size: 1.3rem;
  letter-spacing: 0.3px;
  margin: 0 0 1.69rem 0;
  line-height: 2rem;
  ${media.tablet`
    margin: .75rem 0 0.38rem 0;
    font-size: .94rem;
    line-height: 1.26;
  `}
`;

const StyledIconComponent = styled(IconComponent)`
  font-size: 1.25rem;
  color: #064C70; // global ?
  line-height: 1.1;
  font-weight: bold;
  ${media.tablet`
    font-size: .88rem;
  `}
`;

class IntroPanel extends Component {
  render() {
    const { show } = this.props;
    return (
      <CSSTransition
        in={show}
        timeout={750}
        classNames="intro"
        unmountOnExit
      >
        {(state) => (
          <StyledCenteredPanel>
            <Content>
              <header>
                <Logo src={logoImg} alt="Klimaschutzoffensive des Handels" />
                <H1>Virtuelle Marktstraße</H1>
              </header>
              <P>
                Gehen Sie auf Entdeckungsreise in der Virtuellen Marktstraße.
                Lassen Sie sich von klimaschutzfreundlichen Lösungen für Einsparungen
                im Einzelhandel inspirieren und informieren Sie sich über Ihren
                realisierbaren Wettbewerbsvorteil.
              </P>
              <TabletUp>
                <StyledIconComponent iconUrl={iconKeys} iconAlt="Icon: Keyboard">
                  PFEILTASTEN LINKS UND RECHTS <br />UM DIE MARKTSTRASSE ZU ERKUNDEN
                </StyledIconComponent>
              </TabletUp>
              <Mobile>
                <StyledIconComponent iconUrl={iconSwipe} iconAlt="Icon: Swipe">
                  SWIPEN UM DIE <br /> MARKTSTRASSE ZU BETRETEN
                </StyledIconComponent>
              </Mobile>
            </Content>
          </StyledCenteredPanel>
        )}
      </CSSTransition>

    );
  }
}

IntroPanel.propTypes = {
  show: PropTypes.bool.isRequired,
};

IntroPanel.defaultProps = {
};

export default IntroPanel;



// WEBPACK FOOTER //
// ./src/components/IntroPanel/IntroPanel.js